export enum UpdateType {
  FreeToPaid = 'free to paid',
  PaidToPaid = 'paid to paid',
  SwitchFreeTrial = 'switch free trial tier',
  CancelFreeTrial = 'cancel free trial',
  CancelFreeTrialFailedPayment = 'cancel free trial after failed payment',
  FreeToFreeTrial = 'free to free trial',
}
export enum BillingFrequency {
  Monthly = 'monthly',
  Yearly = 'yearly',
}
